import { component } from 'picoapp';
import scrollama from 'scrollama';

export default component(async (node) => {
  const classes = {
    media: {
      active: 'media-scroll__media--active',
    },
    content: {
      active: 'media-scroll__content--active',
    },
  };
  const scroller = scrollama();
  const medias = node.querySelectorAll('.media-scroll__media');

  scroller
    .setup({
      step: node.querySelectorAll('.media-scroll__content'),
    })
    .onStepEnter(({ element, index }) => {
      element.classList.add(classes.content.active);
      medias[index].classList.add(classes.media.active);
    })
    .onStepExit(({ direction, element, index }) => {
      if (direction === 'up' && index === 0) {
        return;
      }

      if (direction === 'down' && index === medias.length - 1) {
        return;
      }

      element.classList.remove(classes.content.active);
      medias[index].classList.remove(classes.media.active);
    });

  document.addEventListener('theme:screen:size-updated', scroller.resize);
});
